/**
 * @pageName EventsDetailsPage
 * @slotType dashboard plugin
 */
export interface OverviewFooterParams {
  /* Event ID.*/ eventId: string;
}
/**
 * @pageName EventsDetailsPage
 * @slotType dashboard plugin
 */
export interface TicketsAndSeatingRightPanelParams {
  /* Event ID.*/ eventId: string;
}
/**
 * @pageName EventsDetailsPage
 * @slotType dashboard plugin
 */
export interface SettingsFooterParams {
  /* Event ID. */ eventId: string;
}
/**
 * @pageName EventsDetailsPage
 * @slotType dashboard plugin
 */
export interface AdditionalFeaturesCardParams {
  /* Event ID.*/ eventId: string;
}
/**
 * @pageName EventsDetailsPage
 * @slotType dashboard plugin
 */
export interface PromotionFooterParams {
  /* Event ID.*/ eventId: string;
}
/**
 * @pageName EventsDetailsPage
 * @slotType dashboard menu plugin
 */
export interface OrderItemsBulkMoreActionsMenuParams {
  /* Selected IDs.*/ selectedIds: string[];
}
/**
 * @pageName EventsDetailsPage
 * @slotType dashboard menu plugin
 */
export interface TicketsGuestItemsBulkMoreActionsMenuParams {
  /* Selected IDs.*/ selectedIds: string[];
}
/**
 * @pageName EventsDetailsPage
 * @slotType dashboard menu plugin
 */
export interface RSVPGuestItemsBulkMoreActionsMenuParams {
  /* Selected IDs.*/ selectedIds: string[];
}
